import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Constants } from 'src/app/common/constants';
import Aos from 'aos';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-cybersecurityservices',
  templateUrl: './cybersecurityservices.component.html',
  styleUrls: ['./cybersecurityservices.component.css']
})
export class CybersecurityservicesComponent implements OnInit {
  selectedTab: string = 'ourtabmission'; 
  baseUrl = Constants.baseUrl;
  isBrowser: any;
  constructor(private viewportScroller: ViewportScroller,  
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta,private router: Router) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit(): void {
    if(this.isBrowser){     
  Aos.init({disable: 'mobile', duration: 2000, delay: 500,});

    Aos.refresh;}
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/cybersecurityservices/"
  },
  "headline": "cybersecurityservices",
  "description": "The rapid pace of technological advancements and growing global instability have created an increasingly unpredictable cyber risk environment.",
  "image": "https://mitresource.com/cybersecurityservices/cybersecurityservices-img.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-10-16"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();  
  }
  private setTitleAndMetaTags(): void {
    // Set page title
    this.titleService.setTitle('cybersecurityservices | Maganti IT');

    // Set meta tags
    this.metaService.addTags([
      { name: 'description', content: "The rapid pace of technological advancements and growing global instability have created an increasingly unpredictable cyber risk environment. " },
      { property: 'og:type', content: 'website' },
      { property: 'link:icon', content: '/assets/images/banners/mit-favicon.png' },
      { property: 'og:title', content: 'cybersecurityservices' },
      { property: 'og:url', content: 'https://mitresource.com/application-services/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/cybersecurityservices/cybersecurityservices-img.png' },
      { property: 'og:description', content: "The rapid pace of technological advancements and growing global instability have created an increasingly unpredictable cyber risk environment. "},
    ]);
  }
  tabs = [
    { id: 'ourtabmission', title: 'Risk Assessment & Vulnerability Management', icon: 'assets/images/cybersecurityservices/assess_image.png' },
    { id: 'ourtabservices', title: 'Network Security & Monitoring',icon: 'assets/images/cybersecurityservices/network_image.png' },
    { id: 'ourtabtechnology', title: 'Endpoint Security',icon: 'assets/images/cybersecurityservices/endpoint_security.png' },
    { id: 'ourdata', title: 'Data Encryption & Privacy Protection' ,icon: 'assets/images/cybersecurityservices/data_encryption.png'},
    { id: 'ourincident', title: 'Incident Response & Recovery',icon: 'assets/images/cybersecurityservices/incident_response.png' },
    { id: 'oursecurity', title: 'Security Awareness Training',icon: 'assets/images/cybersecurityservices/secure_Training.png' },
    { id: 'ourmanagement', title: 'Compliance Management & Auditing',icon: 'assets/images/cybersecurityservices/complaince_management.png' },
  ];

  // Method to switch tabs
  openTab(tabId: string) {
    this.selectedTab = tabId;
  }
  brandLogoSlider = {
    slidesToShow: 6,
    slidesToScroll: 1,
    loop: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    breakpoints: {
        1499: {
            slidesPerView: 6
        },

        991: {
            slidesPerView: 4
        },

        767: {
            slidesPerView: 3

        },

        575: {
            slidesPerView: 2
        }
    }
};
swiperBreakpoints = {
  320: { slidesPerView: 2 },      
  768: { slidesPerView: 4 },      
  1024: { slidesPerView: 6 }      
};
}
